// http-response.interceptor.ts
import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { AppCookieService } from 'src/app/utils/AppCookieService';

export const HttpResponseInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const tokenService = inject(JWTTokenServiceService);
  const cookieService = inject(AppCookieService);
  const router = inject(Router);
  const token = tokenService.getToken();

  request = request.clone({
    headers: request.headers.set('Authorization', `Bearer ${token}`)
  });

  return next(request).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse && event.status === 200) {
          // Optional: Handle success
        }
      },
      error: (error) => {
        if (error.status === 403) {
          // Token expired or unauthorized — clear token and redirect to login
          cookieService.remove('token');
          router.navigate(['/login']);
        } else if (error.error instanceof ErrorEvent) {
          console.log('Client side error:', error.error.message);
        } else {
          console.log(`Error Code: ${error.status}, Message: ${error.message}`);
        }
      }
    })
  );
};
